import React, {useRef, useEffect} from 'react';
import ToggleMenu from "@ignitesales/neuro-application/src/neuro-ui/lib/ToggleMenu/ToggleMenu";
import PropTypes from "prop-types";
import {ContactFlow, NeuroMessage, useGuideConfig, notifySuccess} from "@ignitesales/neuro-application";

const CompleteGuideFlow = ({ hasTransmittedLead, formIsVisible, onCloseForm, onFormSubmission }) => {
  const { guideType } = useGuideConfig();
  const isBusinessGuide = guideType === 'business';
  const cssBEM = "completeGuideFlow";

  const formSubmitted = lead => {
    onFormSubmission(lead);
    notifySuccess('contactFormSubmitted');
  };

  const focusContactForm = useRef(null);
  useEffect(() => {
    if(formIsVisible) {
      focusContactForm.current.focus();
    }
  }, [formIsVisible]);

  return <ToggleMenu className={ cssBEM } animation="slideFromRight" isOpen={formIsVisible} onOuterClick={onCloseForm}>
    <button onClick={onCloseForm} className={`${cssBEM}__close`} tabIndex="0" role="button" aria-label="Close" ref={focusContactForm}/>

    <div className={`${cssBEM}__title`}>
      <NeuroMessage id='completeGuide.title' tagName='h1'/>
      <NeuroMessage id={ hasTransmittedLead ? 'completeGuide.subtitle.completed' : 'completeGuide.subtitle'} tagName='span'/>
    </div>

    <div className={`${cssBEM}__steps`}>
      {!hasTransmittedLead &&
        <section>
          <ContactFlow
            useAppointmentFlow={false}
            onContactFormSubmit={formSubmitted}
            onComplete={onCloseForm}
            guideType={isBusinessGuide ? 'business' : 'consumer'}
            shouldValidateOnBlur
            useBusinessFields={isBusinessGuide}
          />
          <div className={`${cssBEM}__warning`}><NeuroMessage id='contactMe.popup' tagName='p'/></div>
        </section>
      }
    </div>
  </ToggleMenu>
};

CompleteGuideFlow.propTypes = {
  cartProducts: PropTypes.array,
  formIsVisible: PropTypes.bool,
  closeForm: PropTypes.func
};

export default CompleteGuideFlow;
